import * as React from 'react';
import { useTheme } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { VseAlertComponent } from './VseAlertComponent';
import * as VseAlert from '../../features/alert';

export interface VseAlertContainerProps extends Pick<React.HTMLAttributes<HTMLElement>, 'className'> {

}

export function VseAlertContainer(props: VseAlertContainerProps) {
  const theme = useTheme();
  const history = useHistory<{
    vseAlerts: VseAlert.VseAlertState
  }>();
  const alertState = VseAlert.useVseAlertState();
  const locAlertState: VseAlert.VseAlertState | undefined = history.location.state && history.location.state.vseAlerts ? history.location.state.vseAlerts : undefined;
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (locAlertState && locAlertState.validationProblemMessages) {
      dispatch(VseAlert.alertValidationProblemMessages(locAlertState.validationProblemMessages));
    }
  }, [dispatch, locAlertState]);

  return (
    <React.Fragment>
      {alertState.successMessages.length === 0 ? undefined : alertState.successMessages.map((s, i) => {
        return (
          <VseAlertComponent
            key={`success-${i}`}
            className={props.className}
            theme={theme}
            severity='success'
            messages={[s]}
            onDismiss={(msgs) => msgs.forEach((msg) => dispatch(VseAlert.dismissSucceeded(msg)))}
          />
        );
      })}
      {alertState.validationProblemMessages.length === 0 ? undefined : (
        <VseAlertComponent
          className={props.className}
          theme={theme}
          title='Error(s)'
          severity='error'
          messages={alertState.validationProblemMessages}
          onDismiss={(msgs) => dispatch(VseAlert.dismissValidationProblem(msgs))}
        />
      )}
      {alertState.serverErrorMessages.length === 0 ? undefined : alertState.serverErrorMessages.map((s, i) => {
        return (
          <VseAlertComponent
            key={`server-${i}`}
            className={props.className}
            theme={theme}
            title='Server Error(s)'
            severity='error'
            messages={[s]}
            onDismiss={(msgs) => msgs.forEach((msg) => dispatch(VseAlert.dismissServerError(msg)))}
          />
        );
      })}
    </React.Fragment>
  );
}
